import React, { useState, useEffect } from 'react';
import { IoClose } from "react-icons/io5";
import Invoice from './Invoice';
import { HiOutlineDownload } from 'react-icons/hi';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { _get } from "../services/apiClient";
import { jwtDecode } from "jwt-decode";
import { formatCurrency } from "../helper/currency";
import { useNavigate } from "react-router-dom";


const styles = {
  btn: {
    borderRadius: '3px',
    border: '1px solid gray',
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    padding: '3px',
    fontSize: '11px',
    color: '#4f4f4f',
    fontWeight: 600,
    cursor: 'pointer',
    userSelect: 'none'
  }
};

const Orders = () => {
  const [orderHistoryData, setOrderHistoryData] = useState([]);
  const [activeTab, setActiveTab] = useState('On Process');
  const [expandedOrderId, setExpandedOrderId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 3;

  const [loading, setLoading] = useState(false);
const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    setOrderHistoryData([]);
    setLoading(true);

    try {
      const decoded = jwtDecode(token);

      if (decoded?.id) {
        const fetchUserDetails = async () => {
          try {
            const res = await _get(`/auth/me/${decoded.id}`);
            if (res.data.success) {
              const user = res.data.user;
              fetchOrderHistory(user._id);
            } else {
              setOrderHistoryData([]);
              setLoading(false);
            }
          } catch (err) {
            console.error("Failed to fetch user:", err);
            setOrderHistoryData([]);
            setLoading(false);
          }
        };

        fetchUserDetails();
      }
    } catch (err) {
      console.error("Invalid JWT:", err);
      setOrderHistoryData([]);
      setLoading(false);
    }

    setCurrentPage(1);

  }, [activeTab]);

  const fetchOrderHistory = async (userId) => {
    try {
      setLoading(true);
      const response = await _get(`/orders/history/${userId}`);
      let order = response.data || response;

      const mappedOrders = order.map(ord => ({
        ...ord,
        items: (ord.products || []).map(p => ({
          name: p.productTitle,
          price: p.price,
          quantity: p.quantity,
          image: (p.images && p.images.length > 0)
            ? p.images[0]
            : 'img/SSL.PNG'
        })),
        totalPrice: ord.amount,
        orderstatus: ord.status
      }));

      let filteredOrders = mappedOrders;
      if (activeTab === 'On Process') {
        filteredOrders = mappedOrders.filter(order =>
          order.orderstatus !== 'completed' && order.orderstatus !== 'reject'
        );
      } else if (activeTab === 'Completed') {
        filteredOrders = mappedOrders.filter(order => order.orderstatus === 'completed');
      } else {
        filteredOrders = mappedOrders.filter(order => order.orderstatus === 'reject');
      }

      setOrderHistoryData(filteredOrders);
    } catch (error) {
      console.log('Error fetching order history:', error);
      setOrderHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-GB");
  };

  const toggleExpand = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };

  // pagination
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orderHistoryData.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(orderHistoryData.length / ordersPerPage);

  return (
    <>
      <section className="py-4 osahan-main-body d-block d-md-block">
        <div className="container" style={{ zIndex: 1500 }}>
          <div className="p-3 d-flex align-items-center ">
            <h4 className="font-weight-bold m-0 text-red">My Orders</h4>
            <span className='ml-auto ' style={{ fontSize: '20px' }}>
              <IoClose onClick={() => navigate(-1)} style={{ cursor: "pointer" }} />

            </span>
          </div>
          <div className="row">
            {/* LEFT SIDE TABS */}
            <div className="col-md-3 mb-3 d-block">
              <ul className="nav nav-tabsa custom-tabsa border-0 flex-column bg-white rounded overflow-hidden shadow-sm p-2 c-t-order" id="myTab" role="tablist" >
                <li className="nav-item" role="presentation">
                  <a className={`nav-link border-0 text-dark py-3 ${activeTab === 'Completed' ? 'active' : ''}`}
                    onClick={() => setActiveTab('Completed')}>
                    <i className="feather-check mr-2 text-success mb-0"></i> Completed
                  </a>
                </li>
                <li className="nav-item border-top " role="presentation">
                  <a className={`nav-link border-0 text-dark py-3 ${activeTab === 'On Process' ? 'active' : ''}`}
                    onClick={() => setActiveTab('On Process')}>
                    <i className="feather-clock mr-2 text-warning mb-0"></i> On Process
                  </a>
                </li>
                <li className="nav-item border-top" role="presentation">
                  <a className={`nav-link border-0 text-dark py-3 ${activeTab === 'Cancelled' ? 'active' : ''}`}
                    onClick={() => setActiveTab('Cancelled')}>
                    <i className="feather-x-circle mr-2 text-danger mb-0"></i> Cancelled
                  </a>
                </li>
              </ul>
            </div>

            {/* RIGHT SIDE ORDERS */}
            <div className="col-md-9" id="myTabContent">
              {loading ? (
                <div className="p-3">Loading orders...</div>
              ) : currentOrders.length === 0 ? (
                <div className="p-3">No orders found.</div>
              ) : currentOrders.map((order) => (
                <div className="tab-pane fade show active" key={order.orderId}>
                  <div className="order-body">
                    <div className="pb-3">
                      <div className="p-3 rounded shadow-sm bg-white">
                        <div className="d-flex border-bottom pb-3 align-items-center">
                          {/* ✅ Only show image if order has items */}
                          {order.items.length > 0 && order.totalPrice > 0 ? (
                            <div className="text-muted mr-3">
                              <img
                                alt="Product"
                                src={`${process.env.REACT_APP_IMAGE_BASE_URL}${order.items[0]?.image}`}
                                className="img-fluid order_img rounded"
                              />
                            </div>
                          ) : (
                            <div
                              className="text-center d-flex align-items-center justify-content-center bg-light rounded mr-3"
                              style={{ width: "60px", height: "60px", color: "#aaa", fontSize: "24px" }}
                            >
                              <i className="feather-x-circle"></i>
                            </div>
                          )}

                          {/* ✅ Order Info */}
                          <div>
                            <p className="mb-0 font-weight-bold">ORDER #{order.orderId}</p>

                            {/* ✅ Hide invoice if total = 0 */}
                            {order.totalPrice > 0 && order.orderstatus !== 'reject' && (
                              <p className="mb-0 small">
                                <PDFDownloadLink
                                  document={<Invoice data={order} />}
                                  fileName={`Invoice-${order.orderId}.pdf`}
                                >
                                  <div style={styles.btn}>
                                    <HiOutlineDownload size={14} />
                                    <span> Invoice </span>
                                  </div>
                                </PDFDownloadLink>
                              </p>
                            )}

                          </div>

                          {/* ✅ Status & Date */}
                          <div className="ml-sm-auto mt-2 mt-sm-0 button">
                            <p
                              className={`bg-${order.orderstatus === "reject"
                                ? "danger"
                                : order.orderstatus === "completed"
                                  ? "success"
                                  : "warning"
                                } text-white py-1 px-2 rounded small mb-1 text-center`}
                            >
                              {order.orderstatus === "reject" ? "Cancelled" : order.orderstatus}
                            </p>
                            <p className="small font-weight-bold text-center ">
                              <i className="feather-clock"></i> {formatDate(order.createdAt)}
                            </p>
                          </div>
                        </div>

                        <div className="pt-3 ">
                          {order.items.length === 0 ? (
                            <div className="text-muted small py-2">
                              <em>This order was cancelled or items were removed by admin.</em>
                            </div>
                          ) : (
                            <>
                              <ul className="item p-1">
                                {order.items.slice(0, 2).map((item, id) => (
                                  <li key={id} style={{ listStyleType: 'none' }}>
                                    <div className="small d-flex justify-content-between">
                                      <span className="font-weight-bold">
                                        {item.name} x {item.quantity}
                                      </span>
                                      {formatCurrency(item.price * item.quantity)}
                                    </div>
                                  </li>
                                ))}
                              </ul>

                              {order.items.length > 2 && expandedOrderId !== order.orderId && (
                                <a href="#a" onClick={e => { e.preventDefault(); toggleExpand(order.orderId) }}>
                                  Show more Items
                                </a>
                              )}
                              {order.items.length > 2 && expandedOrderId === order.orderId && (
                                <>
                                  <ul className="item p-0">
                                    {order.items.slice(2).map((item, id) => (
                                      <li key={id} style={{ listStyleType: 'none' }}>
                                        <div className="small d-flex justify-content-between">
                                          <span className="font-weight-bold">{item.name} x {item.quantity}</span>
                                          {formatCurrency(item.price * item.quantity)}
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                  <a href="#a" onClick={e => { e.preventDefault(); toggleExpand(order.orderId) }}>
                                    Show fewer items
                                  </a>
                                </>
                              )}
                            </>
                          )}
                        </div>

                        <div className="text-muted m-0 ml-sm-auto mr-3 small">Total Payment
                          <br /><span className="text-dark font-weight-bold">
                            {formatCurrency(order.totalPrice)}
                          </span>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center my-3">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                    className="btn btn-sm btn-outline-secondary mx-1"
                  >
                    Prev
                  </button>

                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .map((pageNum, idx, arr) => {

                      if (
                        pageNum === 1 ||
                        pageNum === totalPages ||
                        (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                      ) {
                        return (
                          <button
                            key={pageNum}
                            onClick={() => setCurrentPage(pageNum)}
                            className={`btn btn-sm mx-1 ${currentPage === pageNum ? 'btn-primary' : 'btn-outline-primary'}`}
                          >
                            {pageNum}
                          </button>
                        );
                      }

                      const prevPage = arr[idx - 1];
                      const nextPage = arr[idx + 1];
                      if (
                        (prevPage && prevPage < pageNum - 1) &&
                        (nextPage && nextPage > pageNum + 1)
                      ) {
                        return <span key={pageNum} className="mx-1">...</span>;
                      }

                      return null;
                    })

                    .filter((item, index, self) => {
                      return !(typeof item === 'string' && item === '...' && self[index - 1] === '...');
                    })
                  }

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                    className="btn btn-sm btn-outline-secondary mx-1"
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Orders;
